<template>
  <div>
    <basic-subheader>
      <template v-slot:filters>
        <div class="p-4">
          <basic-input label="Tên khách hàng" placeholder="Nhập tên khách hàng" name="name" class="route-input"
            :value.sync="filter.name" :debounce="500" @v-modal:update="searchDebounce"></basic-input>
        </div>
      </template>
      <template v-slot:actions>
        <!-- <b-button v-if="isWriteAllPermission || isWriteOwnerPermission" class="btn btn-success" type="button"
          @click.stop="showZaloModal" style="margin-right: 10px">
          Zalo User
        </b-button> -->
        <b-button v-if="isInsertPermission" class="btn btn-success" type="button"
          @click.stop="showZaloListModal" style="margin-right: 10px;">
          Danh sách nhóm
        </b-button>

        <b-button v-if="isInsertPermission" class="btn btn-success mr-2"
          @click="importCustomer">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/File/file-download.svg" />
          </span>
          Import
        </b-button>
        <b-button v-if="isInsertPermission" class="btn btn-success" type="button"
          @click.stop="createCustomerReceive">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Thêm mới
        </b-button>
        <zalo-list-modal />
        <modal-import @import-success="loadData(true)" :coachesList="coaches" />
      </template>
    </basic-subheader>
    <b-overlay rounded="sm">
      <template>
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table :column="column" :data="data" :paging="paging" :tableAction="false"
                  :searchAction="false" :selectAction="false" @search="searchRequest" @reset="resetRequest"
                  @sortBy="sortRequest">
                  <template v-slot:body="{ item }">
                    <td class="text-left mw-150">
                      {{ item.name }}
                      <span v-if="item.zaloGroupId === 'NO_ZALO_GROUP'" class="badge-no-zalo">Không nhóm</span>
                      <span v-else-if="sharedZaloGroupCount(item) > 1 || isSharedZaloGroup(item)"
                        class="badge-shared-group" :title="`Nhóm Zalo: ${item.zaloGroupId}`">Nhóm chung</span>
                      <!-- Xuống dòng riêng dưới tên, độc lập với badge nhóm Zalo:
                           một khách có thể vừa đã có tài khoản vừa chưa có nhóm -->
                      <div v-if="item.hasAccount" class="badge-has-account__row">
                        <span class="badge-has-account">Đã có tài khoản</span>
                      </div>
                    </td>

                    <td class="text-center">
                      <span v-if="item.isZaloLinked === true" class="badge-login-type badge-zalo">Zalo</span>
                      <span v-else-if="item.isZaloLinked === false" class="badge-login-type badge-google"><img src="/media/svg/logos/google-icon.svg" class="badge-google__icon" alt="" />Google</span>
                      <span v-else>{{ item.phoneNumber }}</span>
                    </td>
                    <!-- <td class="text-center w-40 cursor-pointer" @click="handleCall(item)">
                      <span class="svg-icon">
                        <inline-svg src="/media/svg/icons/Neolex/Call/call-phone.svg" />
                      </span>
                    </td> -->
                    <td class="text-center">
                      <a :href="`https://zalo.me/${item.phoneNumber}`" target="_blank" v-if="item.zaloVerify === false">
                        <div class="d-flex justify-content-center">
                          <span class="svg-icon">
                            <inline-svg src="/media/svg/icons/Neolex/Basic/search.svg" />
                          </span>
                        </div>
                      </a>
                      <div class="d-flex justify-content-center">
                        <v-checkbox dense class="checkbox-role" v-model="item.zaloVerify" @change="changeStatus(item)"
                          :disabled="item.zaloVerify === true"></v-checkbox>
                      </div>
                    </td>
                    <td class="text-center">
                      {{
                        item.gender === 1
                          ? 'Nam'
                          : item.gender === 2
                            ? 'Nữ'
                            : 'Khác'
                      }}
                    </td>
                    <td class="text-center">
                      {{ getTitleName(item.title) }}
                    </td>
                    <td class="text-center">
                      {{ item.birthYear }}
                    </td>
                    <td class="text-center mw-150">
                      {{ item.contactSource }}
                    </td>
                    <td class="text-center mw-150" style="width: 30px">
                      {{ getNameOf('coach', item.coachId) }}
                    </td>
                    <!-- <td class="text-center">
                      {{ item.onboardGroup || '' }}
                    </td> -->
                    <td class="text-center">
                      {{ getPackageName(item.packageId) }}
                    </td>
                    <td class="text-center">
                      {{ getPackageCode(item.packageId) }}
                    </td>
                    <!-- <td>
                      {{ getPartnerName(item.customerPartnerId) }}
                    </td> -->
                    <td>
                      <div class="d-flex flex-column ml-5">
                        <a @click="confirmItem(item)" class="cursor-pointer">
                          <p class="mb-0 module-list-page__body__updater-name text-center confirm">
                            {{ statuses[1].text }}
                          </p>
                        </a>
                        <a @click="moveToPotentialItem(item)" class="cursor-pointer">
                          <p class="mt-2 mb-0 module-list-page__body__updater-code text-center refuse">
                            {{ statuses[0].text }}
                          </p>
                        </a>
                      </div>
                    </td>
                    <td style="width: 20px">
                      <action-dropdown :value="item" :show_copy="false" :show_delete="false" :show_edit="false"
                        :show_view="false">
                        <template>
                          <b-dropdown-text tag="div" class="navi-item cursor-pointer" @click="detailCustomer(item)">
                            <a class="navi-link text-primary">
                              <span class="menu-icon svg-icon svg-icon-sm">
                                <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/eye.svg" />
                              </span>
                              <span class="navi-text text-primary">Xem chi tiết</span>
                            </a>
                          </b-dropdown-text>
                          <b-dropdown-divider v-if="isDeletePermission"></b-dropdown-divider>
                          <b-dropdown-text v-if="isDeletePermission" tag="div" class="navi-item cursor-pointer" @click="deleteCustomer(item)">
                            <a class="navi-link text-danger">
                              <span class="menu-icon svg-icon svg-icon-sm">
                                <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/power.svg" />
                              </span>
                              <span class="navi-text text-danger">Xóa dữ liệu</span>
                            </a>
                          </b-dropdown-text>
                        </template>
                      </action-dropdown>
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>
    </b-overlay>
    <call-client :targetItem="currentItem" @load-data="loadData" />
    <reason-question :targetItem="currentItem" :title="currentTitle" @load-data="loadData" />
    <modal-detail :targetItem="currentItem" @load-data="loadData" :packagesName="packagesName" />
    <modal-accept :targetItem="currentItem" @load-data="loadData" @switch-tab="switchTab" />
    <modal-create @load-data="loadData" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import DatePicker from 'vue2-datepicker';
import moment from 'moment-timezone';
import { getPendingJob, clearPendingJob } from './ImportModal.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('customerReceives');



export default {
  props: {},
  name: 'CustomerReceiveTab',
  components: {
    //  'date-picker': DatePicker,
    'call-client': () => import('./CallModal.vue'),
    'reason-question': () => import('./ReasonModal.vue'),
    'modal-import': () => import('./ImportModal.vue'),
    'modal-create': () => import('./CreateModal.vue'),
    'modal-accept': () => import('./AcceptModal.vue'),
    'modal-detail': () => import('./DetailModal.vue'),
    'zalo-list-modal': () => import('@/view/pages/courses/components/ZaloListModal.vue'),

  },
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      data: [],
      loading: false,
      statuses: [
        {
          text: 'Từ chối',
          value: 0,
        },
        {
          text: 'Xác nhận',
          value: 1,
        },
      ],
      // partners: [],
      coaches: [],
      courses: [],
      genders: [],
      sort: {
        by: null,
        order: null,
      },
      column: [
        {
          key: 'name',
          label: 'Khách hàng',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },

        {
          key: 'phoneNumber',
          label: 'Số điện thoại',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        // {
        //   key: 'call',
        //   label: '',
        //   sortable: false,
        //   style: {
        //     'text-align': 'center',
        //   },
        // },
        {
          key: 'zaloVerify',
          label: 'Zalo',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'gender',
          label: 'Giới tính',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'title',
          label: 'Danh xưng',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'birthYear',
          label: 'Năm sinh',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'contactSource',
          label: 'Nguồn',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'coach',
          label: 'Coach phụ trách',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        // {
        //   key: 'onboardGroup',
        //   label: 'Nhóm',
        //   sortable: false,
        //   style: {
        //     'text-align': 'center',
        //   },
        // },
        {
          key: 'packageName',
          label: 'Gói dịch vụ',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: 'packageCode',
          label: 'Mã gói',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        // {
        //   key: 'CustomerPartnerName',
        //   label: 'Đối tác',
        //   sortable: false,
        //   style: {
        //     'text-align': 'center',
        //   },
        // },
        {
          key: 'action',
          label: '',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
        {
          key: '',
          label: '',
          sortable: false,
          style: {
            'text-align': 'center',
          },
        },
      ],
      filterNoZalo: false,
      filter: {
        name: null,
        phoneNumber: null,
        gender: null,
        birthYear: null,
        contactSource: null,
        status: 0,
        coachId: null,
        reasonOut: null,
        createDatetime: [
          moment().format('MM/DD/YYYY'),
          moment().format('MM/DD/YYYY'),
        ],
      },
      currentItem: {},
      currentTitle: null,
      packagesName: [],
      zaloVerify: null,
    };
  },
  computed: {
    // Đếm khách dùng chung một nhóm Zalo trong trang hiện tại, theo zaloGroupId
    zaloGroupCounts() {
      const counts = {};
      (this.data || []).forEach((row) => {
        const groupId = row && row.zaloGroupId;
        if (!groupId || groupId === 'NO_ZALO_GROUP') return;
        counts[groupId] = (counts[groupId] || 0) + 1;
      });
      return counts;
    },
    ...mapGetters(['layoutConfig']),
    // ...mapState(['partners']),
    searchParams() {
      const payload = this.removeEmpty({
        name: this.filter.name,
        status: this.filter.status,
        genders: this.filter.genders,
        coachId: this.filter.coachId,
        contactSource: this.filter.contactSource,
        page: this.paging.page,
        size: this.paging.pageSize,
        startDate: moment(this.filter.createDatetime[0]).format('MM/DD/YYYY'),
        dueDate: moment(this.filter.createDatetime[1]).format('MM/DD/YYYY'),
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }
      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      // Đang ở trang 5 mà đổi 10 -> 50 thì page=5 vượt quá số trang mới, API trả rỗng.
      // Gán page = 1 để watcher 'paging.page' lo gọi loadData, tránh bắn 2 request.
      if (this.paging.page !== 1) {
        this.paging.page = 1;
        return;
      }
      this.loadData();
    },

  },
  methods: {
    ...mapActions(['setCourses', 'setCoaches'/* , 'setPartners' */]),
    switchTab(tabName) {
      this.$emit('switch-tab', tabName);
    },
    searchRequest() {
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },
    // Hai hàm này chạy trong render của từng dòng nên phải THUẦN: không ghi vào
    // state, không đọc state vừa ghi. Ghi rồi đọc lại chính nó sẽ khiến render
    // watcher phụ thuộc vào biến đó, mỗi dòng ghi một giá trị khác -> lặp vô hạn.
    getPackageName(item) {
      const list = Array.isArray(this.packagesName) ? this.packagesName : [];
      return list.find((p) => p.id === item)?.name ?? null;
    },
    getPackageCode(item) {
      const list = Array.isArray(this.packagesName) ? this.packagesName : [];
      return list.find((p) => p.id === item)?.code ?? null;
    },
    // getPartnerName(partId) {
    //   const part = this.partners.find((item) => item.id === partId);
    //   return part ? part.value.split(',')[0].trim() : '';
    // },
    resetRequest() {
      this.filter.name = null;
      this.filter.phoneNumber = null;
      this.filter.gender = null;
      this.filter.status = null;
      this.filter.coachId = null;
      this.filter.contactSource = null;

      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    createCustomerReceive() {
      this.$bvModal.show('create-modal');
    },
    // showZaloModal() {
    //   this.$bvModal.show('zalo-list-user-modal');
    // },
    async loadData() {
      try {
        this.loading = true;
        const { data, meta } = await this.$api.get('CustomerReceives', {
          params: this.searchParams,
        });

        this.data =
          (data || []).map((el) => {
            return {
              ...el,
            };
          }) || [];
        this.paging.total = meta.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async getSearchDataPrepare() {
      this.loading = true;
      await this.$api
        .get('CustomerReceives/PrepareSearchFormItem')
        .then(({ data }) => {
          const { coaches } = data;
          this.coaches = coaches?.map((c) => {
            return {
              text: c?.coachName,
              value: c?.coachId,
            };
          });
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
          return Promise.reject(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // async getDoctorHopTac() {
    //   // this.$store.commit('context/setLoading', true);
    //   try {
    //     const storedData = sessionStorage.getItem('DoctorHoptac');
    //     if (storedData) {
    //       this.partners = JSON.parse(storedData);
    //       //    this.$store.commit('context/setLoading', false);
    //       return;
    //     }
    //     const { data } = await this.$api.get('Account/RoleDoctorPartner');
    //     this.partners = data.map((d) => {
    //       const fullName = d.fullName || 'Không rõ tên';
    //       const tagName =
    //         d.accountRule?.accountRuleTagMappings?.[0]?.tag?.name || '';
    //       return {
    //         id: d.id,
    //         value: `${fullName}, Bệnh viện: ${tagName}`,
    //       };
    //     });
    //     sessionStorage.setItem('DoctorHoptac', JSON.stringify(this.partners));
    //   } catch (error) {
    //     this.$toastr.e({
    //       title: 'Lỗi',
    //       msg: 'Không thể tải danh sách đối tác: ' + error.message,
    //     });
    //   } finally {
    //     // this.$store.commit('context/setLoading', false);
    //   }
    // },
    async getDataCourses() {
      await this.$api
        .get('Courses')
        .then(({ data }) => {
          const items = data.items.filter((x) => x.status === 0);
          this.courses = items?.map((c) => {
            return {
              text: c?.name,
              value: c?.id,
              startDatetime: c?.startDatetime,
              endDatetime: c?.endDatetime,
            };
          });
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
          return Promise.reject(error);
        });
    },
    handleCall(item) {
      this.currentItem = item;
      this.$bvModal.show('call-modal');
    },
    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);

      this.$swal({
        title: 'Xác nhận',
        text: `Số điện thoại này sử dụng Zalo ?`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      }).then(
        async function (result) {
          if (result) {
            await this.verifyZaloNumber(item);
          }
        }.bind(this),
      );

      this.$store.commit('context/setLoading', false);
    },
    async verifyZaloNumber(item) {
      const formData = new FormData();
      if (item.yearOfIllness === null) {
        formData.append('yearOfIllness', '');
      }
      if (item.onboardGroup === null) {
        formData.append('onboardGroup', '');
      }

      // Append gender separately with proper value check
      if (item.gender === 1 || item.gender === 2) {
        formData.append('gender', item.gender);
      }

      Object.keys(item).forEach((key) => {
        if (key == 'isDeleted') {
          formData.append('isDeleted', !!item.isDeleted);
        } else if (key === 'timeAccepted' || key === 'gender') {
          // Skip - gender handled above
        } else if (key === 'zaloVerify') {
          formData.append('zaloVerify', item[key] === true ? true : false);
        } else if (key === 'callCount') {
          formData.append('callCount', item[key] || 0);
        } else formData.append(key, item[key]);
      });

      try {
        await this.$api.put(`/CustomerReceives/${item.id}`, formData);
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Cập nhật thành công',
        });
      } catch (error) {
        this.$store.commit('context/setLoading', false);
        return this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
      this.loadData();
    },
    searchDebounce(value) {
      this.filter.name = value;
      this.resetPaging();
    },
    searchDate() {
      if (
        this.filter.createDatetime[0] == null &&
        this.filter.createDatetime[1] == null
      ) {
        this.filter.createDatetime = [
          moment().format('MM/DD/YYYY'),
          moment().format('MM/DD/YYYY'),
        ];
      }
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    importCustomer() {
      this.$bvModal.show('modal-import');
    },
    // Admin có thể đóng modal khi import đang chạy nền. Vào lại màn thì báo kết quả.
    async checkPendingImportJob() {
      const pending = getPendingJob();
      if (!pending || !pending.jobIds || !pending.jobIds.length) return;

      try {
        // Một lần import gồm nhiều job, hỏi tiến độ gộp của tất cả
        const { meta, data } = await this.$api.post(
          'CustomerReceives/ImportCustomerReceives/jobs-progress',
          pending.jobIds,
          { headers: { 'Content-Type': 'application/json' } },
        );

        // Còn job đang chạy thì để lần sau. Không tra được (hết hạn lưu trữ) thì vẫn
        // báo kết quả được, vì số liệu thật lấy từ bảng tiếp nhận chứ không từ job.
        if (meta.success && data && !data.finished) return;

        clearPendingJob();
        await this.reportImportResult(pending.phoneNumbers);
      } catch {
        // Không tra được thì để nguyên, lần sau thử lại
      }
    },
    async reportImportResult(phoneNumbers) {
      if (!phoneNumbers || !phoneNumbers.length) return;

      const { meta, data } = await this.$api.post(
        'CustomerReceives/ImportCustomerReceives/status',
        phoneNumbers,
        { headers: { 'Content-Type': 'application/json' } },
      );
      if (!meta.success || !data) return;

      const joined = data.filter((r) => r.status === 1).length;
      const imported = data.filter((r) => r.imported && r.status !== 1).length;
      const missing = data.filter((r) => !r.imported).length;

      const parts = [`${joined}/${data.length} đã tiếp nhận`];
      if (imported) parts.push(`${imported} chưa tiếp nhận`);
      if (missing) parts.push(`${missing} chưa vào được`);

      const msg = parts.join(', ') + '.';

      if (missing || imported) {
        this.$toastr.w({ title: 'Import xong', msg });
      } else {
        this.$toastr.s({ title: 'Import xong', msg });
      }

      this.loadData();
    },
    // Nhom Zalo dung chung (gan tu man import) -> badge "Nhom chung".
    // Uu tien co tu BE; khong co co thi khong hien badge de tranh bao sai.
    sharedZaloGroupCount(item) {
      const groupId = item && item.zaloGroupId;
      if (!groupId || groupId === 'NO_ZALO_GROUP') return 0;
      return this.zaloGroupCounts[groupId] || 0;
    },
    isSharedZaloGroup(item) {
      if (!item) return false;
      if (item.isSharedZaloGroup === true) return true;
      return (
        !!item.zaloGroupId &&
        item.zaloGroupId !== 'NO_ZALO_GROUP' &&
        item.bypassCreateZaloGroup === true
      );
    },
    confirmItem(item) {
      this.currentItem = {
        ...item,
        // customerPartnerName: this.getPartnerName(item.customerPartnerId),
        packageName: this.getPackageName(item.packageId),
        packageCode: this.getPackageCode(item.packageId),
      };
      this.$bvModal.show('accept-modal');
    },
    moveToPotentialItem(item) {
      this.currentItem = item;
      this.currentTitle = 'Lý do chuyển người dùng thành khách hàng tiềm năng';
      this.$bvModal.show('reason-modal');
    },
    getNameOf(key, value) {
      switch (key) {
        case 'coach':
          return (
            this.coaches?.find((item) => item.value == value)?.text ?? null
          );
        // case 'partner':
        //   return (
        //     this.partners?.find((item) => item.value == value)?.text ?? null
        //   );
      }
    },
    getTitleName(value) {
      const titles = {
        0: 'Cô',
        1: 'Chú',
        2: 'Anh',
        3: 'Chị',
        4: 'Em',
      };
      return titles[value] || '';
    },
    changeReasonOutItem(item) {
      this.currentItem = item;
      this.currentTitle = 'Ghi chú';
      this.$bvModal.show('reason-modal');
    },
    deleteCustomer(item) {
      this.$swal({
        title: '',
        text: `Dữ liệu của khách hàng "${item.name}" sẽ bị xóa vĩnh viễn khỏi hệ thống và không thể khôi phục. Bạn có chắc chắn muốn xóa không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `Xóa vĩnh viễn`,
            value: true,
            visible: true,
            className: `btn btn-inactive`,
            closeModal: true,
          },
        },
      }).then(
        async function (result) {
          if (!result) return;
          try {
            await this.$api.delete(`CustomerReceives/HardDelete/${item.id}`);
            this.loadData();
            this.$toastr.s({
              title: 'Thành công !',
              msg: 'Đã xóa vĩnh viễn dữ liệu khách hàng.',
            });
          } catch (error) {
            this.$toastr.e({
              title: 'Lỗi !',
              msg: error.message || 'Không thể xóa dữ liệu khách hàng.',
            });
          }
        }.bind(this),
      );
    },
    detailCustomer(item) {
      this.currentItem = item;
      this.$bvModal.show('customer-receive-detail-modal');
    },
    async GetPackage() {
      await this.$api
        .get('/Package')
        .then((response) => {
          // Phải luôn là mảng: getPackageName chạy trong slot của từng dòng, nếu đây
          // không phải mảng thì .find ném lỗi và Vue bỏ render cả tbody -> bảng trắng
          // dù API danh sách trả đủ dữ liệu.
          const raw = response.data;
          this.packagesName = Array.isArray(raw) ? raw : raw?.items ?? [];
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    },
    stripHtml(html) {
      // Create a temporary element and use the browser to strip tags
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
    showZaloListModal() {
      this.$bvModal.show('zalo-list-modal');
    },

    // Nhóm Zalo tự giải tán sau 45 ngày không gia hạn -> cảnh báo sớm khi còn <= 7 ngày
    isGroupExpiring(dateStr) {
      if (!dateStr) return false;
      const [day, month, year] = dateStr.split('/').map(Number);
      if (!day || !month || !year) return false;
      const validDate = new Date(year, month - 1, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const diffDays = Math.ceil((validDate - today) / (1000 * 60 * 60 * 24));
      return diffDays <= 7;
    },

    // Vào màn Tiếp nhận: nếu có nhóm sắp hết hạn thì tự mở danh sách nhóm để xử lý
    async autoOpenExpiringGroups() {
      try {
        // Lặp hết các trang (Zalo 50 nhóm/lần), không thì bỏ sót nhóm xếp sau
        const groups = [];
        for (let offset = 0; offset < 1000; offset += 50) {
          const res = await this.$api.get('/ZaloZnsLog/GetValidGroupOA', {
            params: { offset, count: 50 },
          });
          const page = res?.data?.groups || [];
          groups.push(...page);
          if (page.length < 50 || offset + 50 >= parseInt(res?.data?.total || 0)) break;
        }
        const expiring = groups.filter((g) =>
          this.isGroupExpiring(g.valid_through),
        );
        if (expiring.length) {
          this.$toastr.w({
            title: 'Cảnh báo',
            msg: `Có ${expiring.length} nhóm Zalo sắp hết hạn, vui lòng gia hạn.`,
          });
        }
      } catch (error) {
        // Tính năng phụ trợ - không chặn màn chính nếu lỗi
        console.error('Check expiring Zalo groups error:', error);
      }
    },

  },

  async created() {
    this.loading = true;
   this.$store.dispatch('layout/toggleSidebar', false);
  
    try {
      // getSearchDataPrepare/getDataCourses đã toast lỗi rồi vẫn reject tiếp. Không
      // nuốt ở đây thì một API phụ hỏng sẽ làm cả created() dừng giữa chừng:
      // loading kẹt true (spinner quay mãi) và bảng không hiện dù loadData đã xong.
      await Promise.all([
        this.loadData(),
        this.getSearchDataPrepare().catch(() => {}),
        this.getDataCourses().catch(() => {}),
        this.GetPackage(),
        // this.getDoctorHopTac(),
      ]);
      this.setCourses(this.courses);
      this.setCoaches(this.coaches);
      // this.setPartners(JSON.parse(sessionStorage.getItem('DoctorHoptac')));
    } finally {
      this.loading = false;
    }

    this.autoOpenExpiringGroups();
    this.checkPendingImportJob();
  },
};
</script>

<style lang="scss" scoped>

.badge-login-type {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 3px;
  vertical-align: middle;
  white-space: nowrap;
}

// Dung dung mau/kieu cua nut dang nhap that tung ben, khong phai mau tuy chon:
//  - Zalo: nen xanh duong thuong hieu #0068FF, chu trang - dung nhu nut cua ho.
//  - Google: nen trang, vien xam, kem icon G 4 mau that - dung nhu nut "Sign in with Google".
.badge-zalo {
  background: #0068ff;
  color: #fff;
  letter-spacing: 0.02em;
}

.badge-google {
  background: #fff;
  color: #3c4043;
  border: 1px solid #dadce0;
  font-weight: 600;

  &__icon {
    width: 11px;
    height: 11px;
    margin-right: 4px;
  }
}

.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 96px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #00c7f9;
  }

  &.warning-color {
    background-color: #ff5756;
  }
}

.customer-list-page__body__tabs::v-deep {
  margin: 0 -2rem -2rem;

  a.nav-link {
    border: 0;

    &.active {
      font-weight: 600;
      color: #01645a !important;
      border-bottom: 2px solid #01645a;
    }
  }

  li.nav-item {
    a.nav-link:hover {
      color: #333;
    }
  }

  .tab-content {
    display: none;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
  max-width: 220px;
}

.mw-400 {
  min-width: 400px;
  max-width: 400px;
}

.mw-150 {
  min-width: 150px;
  max-width: 150px;
}

.mw-200 {
  min-width: 200px;
  max-width: 200px;
}

.mw-250 {
  min-width: 250px;
  max-width: 250px;
}

.w-40 {
  width: 40px;
}

.mw-157 {
  width: 157px;
}

.confirm {
  color: #28a745;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background-color: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.2);
  display: inline-block;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-size: 0.75rem;
  min-width: 60px;
  text-align: center;
}

.confirm:hover {
  background-color: rgba(40, 167, 69, 0.2);
  color: #1e7e34;
}

.refuse {
  color: #dc3545;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.2);
  display: inline-block;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-size: 0.75rem;
  min-width: 60px;
  text-align: center;
}

.refuse:hover {
  background-color: rgba(220, 53, 69, 0.2);
  color: #bd2130;
}

.text-black {
  color: #333;
}

.badge-no-zalo {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(139, 92, 246, 0.12);
  color: #7c3aed;
  border: 1px solid rgba(139, 92, 246, 0.3);
  vertical-align: middle;
  margin-left: 4px;
  white-space: nowrap;
}

// Nằm hẳn một dòng dưới tên nên bỏ margin-left của badge bên trong
.badge-has-account__row {
  margin-top: 3px;

  .badge-has-account {
    margin-left: 0;
  }
}

// Xanh lá: đây là thông tin trung tính/tích cực, phân biệt với tím "Không nhóm"
// và xanh dương "Nhóm chung" để admin không phải đọc chữ mới biết badge nào là badge nào.
.badge-has-account {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(33, 165, 103, 0.12);
  color: #1a7d4f;
  border: 1px solid rgba(33, 165, 103, 0.35);
  vertical-align: middle;
  margin-left: 4px;
  white-space: nowrap;
}

.badge-shared-group {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(37, 154, 187, 0.12);
  color: #1b7f9c;
  border: 1px solid rgba(37, 154, 187, 0.35);
  vertical-align: middle;
  margin-left: 4px;
  white-space: nowrap;
}
</style>
